import React from "react";
import useTheme from "../../hooks/useTheme";
import { ThemeInterface } from "../../services/exports/Interfaces";

interface Props {
  className?: string;
  color?: string;
  style?: Object;
}

export default function OrderCountIcon(props: Props) {
  const { color, className, style } = props;
  const theme: ThemeInterface = useTheme();
  return (
    <svg
      className={className ?? "h-6 w-6"}
      viewBox="0 0 69 80"
      fill="none"
      style={style}
    >
      <path
        d="M0 66.8945C0 70.9961 1.04166 74.0723 3.12498 76.1231C5.20831 78.1738 8.31705 79.1992 12.4512 79.1992H57.6172C61.1002 79.1992 63.8184 78.1738 65.7715 76.1231C67.7246 74.0723 68.7012 70.9961 68.7012 66.8945V27.5879C68.7012 23.4864 67.6595 20.4102 65.5762 18.3594C63.4928 16.3086 60.3841 15.2832 56.25 15.2832H50.6348C50.5371 12.5163 49.7396 9.9772 48.2422 7.666C46.7448 5.3548 44.7754 3.49934 42.334 2.0996C39.8926 0.699868 37.2233 0 34.3262 0C31.4616 0 28.8086 0.699868 26.3672 2.0996C23.9258 3.49934 21.9564 5.3548 20.459 7.666C18.9616 9.9772 18.164 12.5163 18.0664 15.2832H12.4512C8.31705 15.2832 5.20831 16.3086 3.12498 18.3594C1.04166 20.4102 0 23.4864 0 27.5879V66.8945ZM7.03128 66.5527V27.9297C7.03128 26.0742 7.51141 24.6826 8.47168 23.7549C9.43195 22.8272 10.791 22.3633 12.5489 22.3633H56.1524C57.9102 22.3633 59.2692 22.8272 60.2295 23.7549C61.1897 24.6826 61.6699 26.0742 61.6699 27.9297V66.5527C61.6699 68.4082 61.2467 69.7998 60.4004 70.7276C59.554 71.6553 58.5938 72.1191 57.5196 72.1191H12.5489C10.791 72.1191 9.43195 71.6553 8.47168 70.7276C7.51141 69.7998 7.03128 68.4082 7.03128 66.5527ZM25.0977 15.2832C25.1627 13.6556 25.6185 12.1908 26.4649 10.8887C27.3112 9.58664 28.4261 8.5531 29.8096 7.7881C31.193 7.0231 32.6986 6.6406 34.3262 6.6406C35.9863 6.6406 37.5 7.0231 38.8672 7.7881C40.2344 8.5531 41.3411 9.58664 42.1875 10.8887C43.0339 12.1908 43.4896 13.6556 43.5547 15.2832H25.0977Z"
        fill={color ?? theme.color.brand.inkGrey.grey_3}
      />
    </svg>
  );
}
